import { render, staticRenderFns } from "./EmotionWheelLegend.vue?vue&type=template&id=78320274"
import script from "./EmotionWheelLegend.vue?vue&type=script&lang=js"
export * from "./EmotionWheelLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78320274')) {
      api.createRecord('78320274', component.options)
    } else {
      api.reload('78320274', component.options)
    }
    module.hot.accept("./EmotionWheelLegend.vue?vue&type=template&id=78320274", function () {
      api.rerender('78320274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Visualisations/EmotionWheelLegend.vue"
export default component.exports